
import { defineComponent } from "vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";

export default defineComponent({
  components: {
    IntegerControl,
  },
  props: {
    model: { required: true },
  },
  methods: {},
  created(){
    this.modelLocal = this.model;
  },
  data(){
    return {
      modelLocal: null,
      weight: [{name: "cabinAxle", top: 345, left: 70},
        {name: "tractorFirstAxle", top: 345, left: 255}, 
        {name: "semitrailerFirstAxle", top: 345, left: 480},
        {name: "semitrailerSecondAxle", top: 345, left: 550},
        {name: "semitrailerThirdAxle", top: 345, left: 620},
        {name: "semitrailerFourthAxle", top: 345, left: 690}],
      distance: [{name: "tractorAxlesDistanceFirst", top: 152, left: 192, width: 40},
        {name: "tractorAxlesDistanceSecond", top: 152, left: 240, width: 40},
        {name: "semitrailerAxlesDistanceFirst", top: 152, left: 587, width: 56},
        {name: "semitrailerAxlesDistanceSecond", top: 152, left: 656, width: 56},
        {name: "tractorCabinAxlesDistance", top: 290, left: 170, width: 56},
        {name: "tractorSemitrailerAxlesDistance", top: 113, left: 380, width: 56}],
    };
  },
});
